import $ from 'jquery';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

class Progress {
    constructor() {
        let self = this;

        self._init();
    }

    _elems = {
        $_       : $(),
        $content : $()
    };

    _state = {
        xhr : null
    };

    _args = {
        object : {}
    };

    _initModal = {
        buildings_with_no_sections : function(data) {
            new Modal({
                 title   : 'Дома без секций',
                 content : Utils.renderProfileTemplate('progress-state-buildings_with_no_sections', data),
             });
        },

        sections_with_no_flats: function(data) {
            new Modal({
                title   : 'Секции без помещений',
                content : Utils.renderProfileTemplate('progress-state-sections_with_no_flats', data)
            });
        },

        flats_with_no_typical_plan: function(data) {
            new Modal({
                title   : 'Помещения без типовых планировок',
                content : Utils.renderProfileTemplate('progress-state-flats_with_no_typical_plan', data)
            });
        },

        buildings_are_not_in_any_plan: function(data) {
            new Modal({
                title   : 'Дома, не отмеченные на плане комплекса',
                content : Utils.renderProfileTemplate('progress-state-buildings_are_not_in_any_plan', data)
            });
        },

        sections_are_not_in_any_facade: function(data) {
            new Modal({
                title   : 'Секции, не отмеченные на изображении фасада дома',
                content : Utils.renderProfileTemplate('progress-state-sections_are_not_in_any_facade', data)
            });
        },

        floors_are_not_in_any_facade: function(data) {
            new Modal({
                title   : 'Этажи, не отмеченные на изображении фасада секции',
                content : Utils.renderProfileTemplate('progress-state-floors_are_not_in_any_facade', data)
            });
        },

        flats_are_not_in_any_plan: function(data) {
            new Modal({
                title   : 'Помещения, не отмеченные на поэтажных планах секции',
                content : Utils.renderProfileTemplate('progress-state-flats_are_not_in_any_plan', data)
            });
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.object   = args.object;
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$_ = self._elems.$content.children('.progress-state');
    };

    _init = () => {
        let self = this;

        self._bindElements();
    };

    update = (args) => {
        let self = this;

        self._state.xhr && self._state.xhr.abort();

        self._setArgs(args);
        self._bindElements();
        if (!self._elems.$_.length) return;

        self._elems.$_.html(Utils.renderProfileTemplate('progress-state', {loading: true}));

        self._state.xhr = Request.send({
            chess_flow : true,
            path       : '/api/objects/' + self._args.object.id + '/progress-state',

            done: function (response) {
                self._elems.$_.html(Utils.renderProfileTemplate('progress-state', Object.assign({loading: false}, response.progress_state)));
                this.xhr = null;
                [
                    'buildings_with_no_sections',
                    'sections_with_no_flats',
                    'flats_with_no_typical_plan',
                    'buildings_are_not_in_any_plan',
                    'sections_are_not_in_any_facade',
                    'floors_are_not_in_any_facade',
                    'flats_are_not_in_any_plan',
                ].forEach(function (element_name) {
                    self._elems.$_.find('.progress-state-element[data-name="' + element_name + '"]').click(function (e) {
                        e.preventDefault();
                        self._initModal[element_name](response.progress_state[element_name]);
                    });
                });
            }
        });
    };
}

export default Progress;